/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './cerf-menu.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i3 from '@angular/material';
import * as i4 from '@angular/router';
import * as i5 from '@angular/common';
import * as i6 from '@angular/cdk/platform';
import * as i7 from '../../../utilities/components/request-support/request-support-button.component.ngfactory';
import * as i8 from '../../../../../../app/modules/utilities/components/request-support/request-support-button.component';
import * as i9 from '../../../../../../app/modules/utilities/services/request-support/request-support.service';
import * as i10 from '../../../../../../app/modules/utilities/services/confirmation-dialog/confirmation-dialog.service';
import * as i11 from '../../../../../../app/modules/layout/components/cerf-menu/cerf-menu.component';
import * as i12 from '../../../../../../app/modules/user/services/auth/auth.service';
import * as i13 from '../../../../../../app/modules/user/services/current-user/current-user.service';
const styles_CerfMenuComponent:any[] = [i0.styles];
export const RenderType_CerfMenuComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_CerfMenuComponent,data:{}});
function View_CerfMenuComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),5,'a',[['class',
      'mat-list-item'],['md-list-item',''],['role','listitem']],[[2,'active',(null as any)],
      [1,'target',0],[8,'href',4]],[[(null as any),'click'],[(null as any),'focus'],
      [(null as any),'blur']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('focus' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,1)._handleFocus()) !== false);
      ad = (pd_0 && ad);
    }
    if (('blur' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,1)._handleBlur()) !== false);
      ad = (pd_1 && ad);
    }
    if (('click' === en)) {
      const pd_2:any = ((<any>i1.ɵnov(_v,4).onClick($event.button,$event.ctrlKey,$event.metaKey,
          $event.shiftKey)) !== false);
      ad = (pd_2 && ad);
    }
    if (('click' === en)) {
      const pd_3:any = ((<any>_co.itemClicked(_v.context.$implicit)) !== false);
      ad = (pd_3 && ad);
    }
    return ad;
  },i2.View_MdListItem_0,i2.RenderType_MdListItem)),i1.ɵdid(1,1097728,(null as any),
      2,i3.MdListItem,[i1.Renderer2,i1.ElementRef,[2,i3.MdList],[2,i3.MdNavListCssMatStyler]],
      (null as any),(null as any)),i1.ɵqud(603979776,1,{_lines:1}),i1.ɵqud(335544320,
      2,{_hasAvatar:0}),i1.ɵdid(4,671744,(null as any),0,i4.RouterLinkWithHref,[i4.Router,
      i4.ActivatedRoute,i5.LocationStrategy],{routerLink:[0,'routerLink']},(null as any)),
      (_l()(),i1.ɵted(5,2,['\n    ','\n  ']))],(_ck,_v) => {
    const currVal_3:any = _v.context.$implicit.url;
    _ck(_v,4,0,currVal_3);
  },(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit.active;
    const currVal_1:any = i1.ɵnov(_v,4).target;
    const currVal_2:any = i1.ɵnov(_v,4).href;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_4:any = _v.context.$implicit.label;
    _ck(_v,5,0,currVal_4);
  });
}
function View_CerfMenuComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'button',[['class',
      'btn-logout mat-button'],['md-button','']],[[8,'disabled',0]],[[(null as any),
      'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.auth.logout()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(1,16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(2,180224,(null as any),0,i3.MdButton,[i1.Renderer2,i1.ElementRef,i6.Platform,
          i3.FocusOriginMonitor],(null as any),(null as any)),i1.ɵdid(3,16384,(null as any),
          0,i3.MdButtonCssMatStyler,([] as any[]),(null as any),(null as any)),(_l()(),
          i1.ɵted(-1,0,['Log Out']))],(null as any),(_ck,_v) => {
    const currVal_0:any = (i1.ɵnov(_v,2).disabled || (null as any));
    _ck(_v,0,0,currVal_0);
  });
}
export function View_CerfMenuComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵeld(1,0,
      (null as any),(null as any),0,'img',[['alt','dnata'],['class','logo'],['src',
          '../../../../../assets/img/logo.png']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),
      i1.ɵeld(3,0,(null as any),(null as any),7,'md-list',[['class','mat-list'],['role',
          'list']],(null as any),(null as any),(null as any),i2.View_MdList_0,i2.RenderType_MdList)),
      i1.ɵdid(4,16384,(null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(5,49152,(null as any),
          0,i3.MdList,([] as any[]),(null as any),(null as any)),i1.ɵdid(6,16384,(null as any),
          0,i3.MdListCssMatStyler,([] as any[]),(null as any),(null as any)),(_l()(),
          i1.ɵted(-1,0,['\n  '])),(_l()(),i1.ɵand(16777216,(null as any),0,1,(null as any),
          View_CerfMenuComponent_1)),i1.ɵdid(9,802816,(null as any),0,i5.NgForOf,[i1.ViewContainerRef,
          i1.TemplateRef,i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),
      (_l()(),i1.ɵted(-1,0,['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),
          i1.ɵeld(12,0,(null as any),(null as any),7,'div',[['class','menu-footer']],
              (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_CerfMenuComponent_2)),i1.ɵdid(15,16384,
          (null as any),0,i5.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(17,
          0,(null as any),(null as any),1,'app-request-support-button',([] as any[]),
          (null as any),(null as any),(null as any),i7.View_RequestSupportButtonComponent_0,
          i7.RenderType_RequestSupportButtonComponent)),i1.ɵdid(18,49152,(null as any),
          0,i8.RequestSupportButtonComponent,[i3.MdDialog,i9.RequestSupportService,
              i10.ConfirmationDialogService],(null as any),(null as any)),(_l()(),
          i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (_ck,_v) => {
        var _co:i11.CerfMenuComponent = _v.component;
        const currVal_0:any = _co.getMenuItems();
        _ck(_v,9,0,currVal_0);
        const currVal_1:any = _co.auth.isAuthenticated();
        _ck(_v,15,0,currVal_1);
      },(null as any));
}
export function View_CerfMenuComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-cerf-menu',
      ([] as any[]),(null as any),(null as any),(null as any),View_CerfMenuComponent_0,
      RenderType_CerfMenuComponent)),i1.ɵdid(1,114688,(null as any),0,i11.CerfMenuComponent,
      [i12.AuthService,i4.Router,i13.CurrentUserService],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export const CerfMenuComponentNgFactory:i1.ComponentFactory<i11.CerfMenuComponent> = i1.ɵccf('app-cerf-menu',
    i11.CerfMenuComponent,View_CerfMenuComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/layout/components/cerf-menu/cerf-menu.component.ngfactory.ts